import type { PopoverArrowProps } from '../PopoverArrow'

const alignmentDirectionMap = {
  above: 'horizontal',
  below: 'horizontal',
  before: 'vertical',
  after: 'vertical',
} as const

export default (config: {
  props: Partial<PopoverArrowProps> & { isRTL?: boolean }
}) => {
  const { props } = config
  const {
    alignment,
    borderWidth,
    height,
    isRTL,
    location,
    offset,
    pointerPositionStyles,
    width,
  } = props

  const alignmentDirection = location && alignmentDirectionMap[location]

  const pointerAlignment = {
    start: {
      horizontal: { insetInlineStart: offset },
      vertical: { insetBlockStart: offset },
    },
    center: {
      horizontal: { insetInlineStart: `calc(50% - ${width! / 2}px)` },
      vertical: { insetBlockStart: `calc(50% - ${height! / 2}px)` },
    },
    end: {
      horizontal: { insetInlineEnd: offset },
      vertical: { insetBlockEnd: offset },
    },
  }

  const pointerLocation = {
    above: {
      insetBlockEnd: `-${height}px`,
    },
    below: {
      insetBlockStart: `-${height}px`,
    },
    before: {
      insetInlineEnd: isRTL
        ? undefined
        : `-${(width! + height! - borderWidth!) / 2}px`,
      insetInlineStart: isRTL
        ? `-${(width! + height! - borderWidth!) / 2}px`
        : undefined,
    },
    after: {
      insetInlineEnd: isRTL
        ? `-${(width! + height! - borderWidth!) / 2}px`
        : undefined,
      insetInlineStart: isRTL
        ? undefined
        : `-${(width! + height! - borderWidth!) / 2}px`,
    },
  }

  const pointerDirection = {
    above: {
      transform: 'rotate(0deg)',
    },
    below: {
      transform: 'rotate(180deg)',
    },
    before: {
      transform: 'rotate(270deg)',
    },
    after: {
      transform: 'rotate(90deg)',
    },
  }

  return {
    default: {
      pointer: {
        display: 'flex',
        position: pointerPositionStyles ? 'absolute' : undefined,

        ...(pointerPositionStyles && {
          ...pointerLocation[location!],
          ...pointerAlignment[alignment!][alignmentDirection!],
          ...pointerDirection[location!],
        }),
      },
    },
  } as const
}
